export default {
  chooseFile: "Choose a file",
  browse: "Browse",
  clearFile: "Delete file",
  info: "Information",
  requiredField: "This field is required",
  at_least_one_field_required: "You must select at least one option in this row.",
  requiredNumberOrFloat: "Please enter a whole or decimal number",
  emailError: "Please enter a valid e-mail address",
  phoneError: "Please enter a valid phone number",
  lastName: "Surname",
  firstName: "First name",
  email: "E-mail",
  address: "Address",
  complement: "Extra line",
  postCode: "Postcode",
  city: "Town/city",
  phone: "Tel.",
  mobile: "Mobile",
  function: "Function",
  actions: "Actions",
  rights: "Rights",
  send: "Send",
  errors: "Errors requiring attention",
  form_validation: "The following fields are required:",
  entitled: "Title",
  title: "Title",
  selectValue: "Select a value",
  uploaded_on: "Uploaded on",
  error_file: "This file does not seem to be available",
  no_skill_error_file: "This skill import is empty",
  download_success: "File downloaded successfully!",
  file_downloading: "Downloading in progress...",
  download_file: "Download file",
  remove_file: "Remove file",
  signed_error: "Error when saving",
  signed_success: "Changes have been saved successfully",
  saving: "Saving...",
  confirm: "Confirm",
  import: "Import",
  error_nofile: "Please add a file",
  error_file_format: "Please add a file in the correct format!",
  error_date: "The start date must fall before the end date",
  link: "Open link",
  dateChoice: "Click to choose a date",
  next: "Next",
  pleaseWait: "Please wait...",
  select: "Select",
  cancel: "Cancel",
  save: "Save",
  leave_without_save: "Leave without save",
  leave_confirmation: "Are you sure you want to close without saving?",
  ok: "OK",
  edit: "Change",
  no: "No",
  yes: "Yes",
  warning: "Please note",
  iConfirm: "Confirm",
  Save: "Save",
  saveFinish: "Saved",
  fileFormatError: "Please select a file in the correct format",
  display: "Display",
  elements: "elements",
  lines: "Lines",
  conditions: {
    title: "Template application condition",
    alerte:
      "By default, this template applies to all cases. If you set conditions below, the template will only apply when all conditions are met (AND logic).",
  },
  pagination: {
    to: "to",
    on: "on",
  },
  submit: "Send",
  back: "Back",
  remove: "Remove",
  typeYourSearch: "Type in a search term",
  sortBy: "Sort by",
  order: "Order",
  desc: "Decreasing",
  asc: "Increasing",
  reset: "Reset",
  filter: "Filter",
  Search: "Search",
  "No data available in the table": "No data available in the table",
  "No data available": "No data available",
  "Please enter or modify your search": "Please enter or edit your search",
  "Please click on the add button": "Please click on the button to add more",
  search: "Search",
  All: "All",
  None: "N/A",
  "PDF export": "PDF export",
  "Excel export": "Excel export",
  "PNG export": "PNG export",
  "SVG export": "SVG export",
  "See statistics": "View statistics",
  multiselect: {
    press_enter: "",
    press_enter_group: "",
    selected: "",
    press_enter_remove: "",
    press_enter_remove_group: "",
    press_enter_create_tag: "Add a value",
    select_option: "",
    no_result: "No results match your search",
    no_options: "Type at least {nb} characters to search results...",
  },
  init_search: "Reset search",
  search_motor: "Search engine",
  file_size_error: "The file is too large, please select one smaller than ",
  maxTagError: "Please make sure you do not enter more than the maximum value",
  minTagError: "Please make sure you do not enter less than the minimum value",
  see_more_fields: "View more fields",
  justificative_piece: "Supporting documents",
  skillRecap: "Skills assessment",
  valid: "Validate",
  unlock: "Unlock",
  light: "Light",
  dark: "Dark",
  system: "System",
  extensions_accepted:
    "Please select a file in one of the following formats: pdf, doc, xls, xlsx, csv, docx, jpeg, svg, bmp, gif or png.",
  tab_error: "rror on this tab",
  regenerate_succes: "ID successfully regenerated!",
  password_validation: {
    title: "Please enter a password that includes:",
    condition1: "A capital letter",
    condition2: "A tiny letter",
    condition3: "A figure",
    condition4: "A special character",
    condition5: "Minimum 12 characters",
  },
  dropzone: {
    release: "Drop the files here to upload it.",
    drop: "Upload the files here or",
    click_here: "click",
    to_upload: "to upload.",
    downloading: "Downloading...",
    file: "File",
    max_files: "Maximum {count} files",
    max_files_message: "You have already reached the file limit.",
    max_file_size: "The file size {name} exceeds the permitted limit.",
    file_extension_error: "The file extension {name} is invalid.",
    error_title: "Please note that some files have not been accepted.",
    file_size_error: "The maximum size per file is {size} MB.",
  },
  upload_signed_document: {
    label: "Upload the signed document",
    one_file: "You must upload at least 1 file",
    file_only: "Please select a PDF file",
    overview: "Preview",
    close: "Close",
    regenerate: "Regenerate",
    option_value: "Value",
    option_label: "Label",
  },
  user_permissions: {
    archive_label: "View archived promotions",
    profile_label: "View all active profiles",
    search_label: "Search...",
    title: "List of user profiles",
    choose_profile: "Select the profile you wish to add",
  },
  form_error: {
    verify_fields: "Some fields in the form contain errors; please check them and resubmit the form",
    minimum_value: "Minimum value: {value}",
    maximum_value: "Maximum value: {value}",
  },
};
